import React from 'react'
import {
    Route,
    withRouter
} from 'react-router-dom'
import {
  connect,
} from 'react-redux';
import UserDeniedComponent from './UserDeniedComponent'
import UserLoggedOutComponent from './UserLoggedOutComponent';



class PrivateRoute extends React.Component {

  render() {
    const { component: Component, loggedIn, user_inactive, user, checkedLogin, ...rest } = this.props
    return (
      <Route
        {...rest} 
        render={props => {
          let element;
          if (checkedLogin) {
            if (loggedIn && user) {
              element = <Component {...props}/>;
            } else if (user_inactive && !loggedIn) {
              element = <UserLoggedOutComponent/>;
            } else {
              element = <UserDeniedComponent/>;
            } 
          } else {
            element = <div>Checking authorization...</div>
          }
          return element;
        }}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    loggedIn: state.write_class.loggedIn,
    user_inactive: state.write_class.user_inactive,
    user: state.write_class.user,
    checkedLogin: state.write_class.checkedLogin
  }
}

export default withRouter(connect(mapStateToProps)(PrivateRoute))


// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js